import { render, staticRenderFns } from "./pi-updata-report-file.vue?vue&type=template&id=a4c28076"
import script from "./pi-updata-report-file.vue?vue&type=script&lang=ts"
export * from "./pi-updata-report-file.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports